import React, { useRef } from 'react';
import './Login.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import { useSignInWithEmailAndPassword, useSendPasswordResetEmail } from 'react-firebase-hooks/auth';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import background from '../../../images/auth-background.jpg';
import SocialAuth from '../SocialAuth/SocialAuth';
import auth from '../../../firebase.init';
import Loading from '../Loading/Loading';

const Login = () => {
    const backgroundImageStyle = {
        backgroundImage: `url(${background})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        zIndex: -1,
        width: '100%',
        // height: '80vh',
        height: '550px',
        opacity: '95%',
        // opacity: '0.25',
        overflow: 'hidden'
    }

    const emailRef = useRef('');
    const passwordRef = useRef('');

    const [
        signInWithEmailAndPassword,
        user,
        loading,
        error,
    ] = useSignInWithEmailAndPassword(auth);
    const [
        sendPasswordResetEmail,
        sending,
        resetEmailError
    ] = useSendPasswordResetEmail(auth);

    const location = useLocation();
    const navigate = useNavigate();

    const from = location?.state?.from?.pathname || '/';

    if (user) {
        navigate(from, {replace: true});
    }

    const handleFormSubmit = event => {
        event.preventDefault();
        const email = emailRef.current.value;
        const password = passwordRef.current.value;
        // console.log('email, " - ", password');

        signInWithEmailAndPassword(email, password);
    }

    const resetPassword = async () => {
        const email = emailRef.current.value;
        if (email) {
            await sendPasswordResetEmail(email);
            toast('Sent Email. Change your password');
        }
        else {
            toast('Please, enter your email address');
        }
    }

    return (
        <div style={backgroundImageStyle} className='p-5 d-flex flex-column align-items-center justify-content-center'>
            <h2 className='text-light mb-4'>Login</h2>
            <Form onSubmit={handleFormSubmit} className='form-container'>
                <Form.Group className="mb-3 " controlId="formBasicEmail">
                    <Form.Control ref={emailRef} className='inputID text-light bg-light bg-opacity-25' type="email" placeholder="Email" required />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Control ref={passwordRef} className='inputID text-light bg-light bg-opacity-25' type="password" placeholder="Password" required />
                </Form.Group>

                {
                    (error || resetEmailError) && <p className='text-danger text-center'>{error?.message} {resetEmailError?.message}</p>
                }
                {
                    (loading || sending) && <Loading></Loading>
                }

                <Button variant="outline-success" type="submit" className='w-100 text-light'>
                    Login
                </Button>
            </Form>
            <Link to='/register' className='text-decoration-none mt-2 text-primary'>New to Wildlife Global?</Link>
            <p className='d-flex align-items-center justify-content-center mb-0'>
                <span className='text-light'>Forget Password?</span>
                <button
                    className='btn btn-link text-decoration-none text-primary cursor-pointer p-2'
                    onClick={resetPassword}>
                    <span>Reset Password</span>
                </button>
            </p>
            <SocialAuth></SocialAuth>
            <ToastContainer></ToastContainer>
        </div>
    );
};

export default Login;